import * as Sentry from '@sentry/browser';
import colors from '../../../../../../../styles/colors';

const getBASColor = (value) => {
  if (value <= 0.33) return colors.shades.danger3;
  if (value <= 0.66) return colors.shades.warning3;
  return colors.shades.success6;
};

/**
 * Retrieves the user engagement scores (BAS and Net Momentum) from big-query through a firebase function.
 *
 * @param {Function} remote - The function to call the remote service.
 * @param {string} userId - The user id whose scores are being requested.
 * @returns {Promise<{basic_aggregate_score: number, net_momentum_score: number}>} -
 * Resolves to an object containing BAS and momentum scores.
 */
const getUserEngagementScores = async (remote, userId) => {
  const response = await remote('getUserEngagementScores', {
    userId,
  });

  if (!response.ok) {
    Sentry.captureException(
      new Error(`Error in retrieving engagement scores for user ${userId}`),
    );
    return { basic_aggregate_score: 0, net_momentum_score: 0 };
  }

  const { data = [] } = await response.json();
  return data[0] || { basic_aggregate_score: 0, net_momentum_score: 0 };
};

const getFeedbackFormUrl = (clientName, clientId, acName, currentScore) => {
  const formUrl = new URL(
    'https://docs.google.com/forms/d/e/1FAIpQLSef6cWfqpVepb2lMASn9Xqzj8hTxfYHHovbz20bEGjLw3Xf8Q/viewform',
  );
  formUrl.searchParams.append('usp', 'pp_url');
  formUrl.searchParams.append('entry.2055555946', clientName);
  formUrl.searchParams.append('entry.566489496', clientId);
  formUrl.searchParams.append('entry.1748941221', acName);
  formUrl.searchParams.append('entry.906235585', currentScore);
  return formUrl.toString();
};

export {
  getBASColor,
  getUserEngagementScores,
  getFeedbackFormUrl,
};
